import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqs = [{
  question: "What is The Prostate Cancer Navigator?",
  answer: "The Prostate Cancer Navigator is a personalized support service that helps you understand your diagnosis, interpret test results, and make confident decisions about your care. I translate complex medical information into clear, actionable guidance so you can move forward with clarity."
}, {
  question: "Who is this service for?",
  answer: "This service is for men at any stage of the prostate cancer journey—from elevated PSA and initial biopsy decisions to treatment selection, second opinions, or recurrence. I also work closely with spouses and family members who want to better support their loved one."
}, {
  question: "What do you actually help with?",
  answer: "I help you understand PSA trends, biopsy and pathology reports, imaging results, and treatment options such as active surveillance, surgery, or radiation. I also help you prepare questions for your doctors and identify potential gaps in your care."
}, {
  question: "Do you give medical advice or replace my doctor?",
  answer: "No. I do not replace your physician or provide medical advice. serve as an independent guide to help you understand your options and have more informed, productive conversations with your care team."
}, {
  question: "How is this different from just talking to my doctor?",
  answer: "Doctor visits are often short and focused on immediate decisions. I provide dedicated time to walk through your entire situation, explain what everything means, and help you think through your options without pressure."
}, {
  question: "Can you help me decide between treatment options?",
  answer: "Yes. I help you understand the pros, cons, and tradeoffs of each option based on your specific situation so you can make a decision that aligns with your goals and priorities."
}, {
  question: "Do you offer virtual consultations?",
  answer: "Yes. All services are available virtually, so you can work with me from anywhere in the country. In-person support may be available locally in the Denver area."
}, {
  question: "How do we get started?",
  answer: "It starts with a free introductory call. We’ll review your situation, discuss your goals, and determine how I can best support you moving forward."
}, {
  question: "Are these services covered by insurance?",
  answer: "Most insurance plans do not cover navigation services. However, many clients use HSA or FSA funds to pay for consultations."
}, {
  question: "Is the information I share with you kept confidential?",
  answer: "I have counseled thousands of patients over the course of 15 years, I am HIPAA certified, and I treat all PHI very seriously, never releasing or sharing information with anyone else."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="15172" id="frequently-asked-questions" className="bg-background py-24 relative overflow-hidden">
      <div ref={ref} className={cn("container mx-auto px-6 transition-all duration-700 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-serif font-medium text-primary mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-muted-foreground text-xl max-w-2xl mx-auto">
              Find clarity and answers regarding our navigation, advocacy, and
              family support services.
            </p>
          </div>

          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} className="border border-border rounded-3xl px-6 bg-card hover:shadow-md transition-shadow duration-300" data-index={i}>
                <AccordionTrigger className="text-[20px] font-semibold font-sans text-primary hover:text-primary/80 hover:no-underline py-6 text-left">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-[18px] leading-[1.6] pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}